var autoSlider = require('../js/slider-autoplay');

function init(){

  var slider = document.querySelector('.slides');
  if(slider){
    autoSlider.sliderSetup(slider)
  }

}

document.addEventListener('DOMContentLoaded', init);